import React from 'react';
import { motion } from 'framer-motion';
import ShieldIcon from '@mui/icons-material/Shield';
export function Guarantee() {
  return <section className="py-12 px-6 bg-brand-choco-deep text-brand-cream" data-id="element-111">
      <div className="max-w-3xl mx-auto text-center" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border border-brand-gold/30 rounded-3xl p-10 md:p-16 bg-brand-choco relative overflow-hidden" data-id="element-113">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-114"></div>

          <ShieldIcon className="text-brand-gold text-6xl mb-6" style={{
          fontSize: 64
        }} data-id="element-115" />

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-gold mb-6" data-id="element-116">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-xl font-medium mb-4" data-id="element-117">
            Abrís los tomos. Aprendés las técnicas.
          </p>

          <p className="text-brand-cream/80 leading-relaxed" data-id="element-118">
            Si en 7 días no encontrás las fórmulas exactas que esperabas o
            sentís que no es para vos: devolución del 100% de tu dinero. Sin
            formularios, sin vueltas, gestionado de manera segura por Hotmart.
          </p>
        </motion.div>
      </div>
    </section>;
}